import { RegionGate, useTenantAssessmentPaths } from "@sg-protect/shell";
import { type PropsWithChildren } from "react";

export function AssessmentRegionGate({ children }: PropsWithChildren) {
    const { root } = useTenantAssessmentPaths();

    return <RegionGate redirectTo={root}>{children}</RegionGate>;
}
